module.exports = __webpack_public_path__ + "img/circle.c7be9f8c.svg";